<br /><br />
<div class="container-fluid py-5">
  <div class="row mb-6 justify-content-center">
    <div class="col-md-1">
      <a class="btn btn-dark btn-sm btn-refresh" (click)="getData()">
        <i class="fa-solid fa-arrow-rotate-right"></i>
      </a>
    </div>
    <div class="col-md-11 text-center">
      <!-- <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(1)">
        Balances
      </a>
      <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(2)">
        Transactions
      </a>
      <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(3)">
        Customers
      </a> -->
      <!-- <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(4)">
        Payments
      </a> -->
     <!--  <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(5)">
        Disputes
      </a>
      <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(6)">
        Refunds
      </a> -->
    </div>
  </div>

  <!-- saldo -->
  <br />
  <h3 class="text-center">
    <strong>Saldo</strong>: {{ currency.toUpperCase() }}
    {{ balance / 100 | number : "1.2-2" }}
  </h3>

  <!-- Balances -->
  <h2 *ngIf="step == 1">Balances</h2>

  <div class="card shadow-sm" *ngIf="step == 1">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Imported</th>
              <th>Commissions</th>
              <th>Total</th>
              <th>Type</th>
              <th>Description</th>
              <th>Creation date</th>
              <th>Available on</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of charges">
              <td>
                {{ item.currency.toUpperCase() }}
                {{ item.amount / 100 | number : "1.2-2" }}
              </td>
              <td>0</td>
              <!-- <td>{{ item.amount }}</td> -->
              <td>{{ item.amount / 100 | number : "1.2-2" }}</td>
              <td>{{ item.object }}</td>
              <td>{{ item.id }}</td>
              <!-- <td>{{ item.created}}</td> -->
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
              <td>dd/MM/yyyy</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Transactions -->
  <h2 *ngIf="step == 2">Transactions</h2>

  <div class="card shadow-sm" *ngIf="step == 2">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Imported</th>
              <th>Payment Method</th>
              <th>Description</th>
              <th>Customer</th>
              <th>Date</th>
              <!-- <th>Refund date</th>
              <th>Reason for payment rejection</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payments">
              <td>
                {{ item.currency.toUpperCase() }}
                {{ item.amount / 100 | number : "1.2-2"
                }}<!-- <span
                class="badge bg-success"
              >
                {{ item.status }}
              </span> -->
                <span
                  class="badge"
                  [ngClass]="
                    item.status == 'succeeded'
                      ? 'badge-success'
                      : 'badge-danger'
                  "
                >
                  {{ item.status }}
                </span>
              </td>
              <!-- {{ item.status ? "Active" : "Inactive" }} -->
              <td>{{ item.payment_method_types[0] }}</td>
              <td>{{ item.id }}</td>
              <td>{{ getCustomerName(item.customer) }}</td>
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
              <!-- <td>falta</td>
              <td>falta</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Customers -->
  <h2 *ngIf="step == 3">Customers</h2>

  <div class="card shadow-sm" *ngIf="step == 3">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Default Payment Method</th>
              <th>Creation</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of customers">
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td></td>
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- payouts -->
  <h2 *ngIf="step == 4">Payments</h2>

  <div class="card shadow-sm" *ngIf="step == 4">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th></th><!-- Amount -->
              <th></th><!-- Destination -->
              <th></th><!-- Arrive by -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payouts">
              <td>
                ${{ item.amount / 100 | number : "1.2-2" }}
                <span class="badge bg-success">
                  {{ item.status }}
                </span>
              </td>
              <td>{{ item.type }}</td>
              <td>
                {{ item.arrival_date * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- disputes -->
  <h2 *ngIf="step == 5">Disputes</h2>

  <div class="card shadow-sm" *ngIf="step == 5">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <!-- <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Default Payment Method</th>
              <th>Creation</th>
            </tr> -->
          </thead>
          <tbody>
            <!-- <tr *ngFor="let item of customers">
              <td>{{ item.name}}</td>
              <td>{{ item.email}}</td>
              <td></td>
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Refunds -->
  <h2 *ngIf="step == 6">Refunds</h2>

  <div class="card shadow-sm" *ngIf="step == 6">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Imported</th>
              <!-- <th>Total</th> -->
              <th>Type</th>
              <th>Description</th>
              <th>Creation date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of refunds">
              <td>
                {{ item.currency.toUpperCase() }}
                {{ item.amount / 100 | number : "1.2-2" }}
              </td>
              <!-- <td>{{ item.amount }}</td> -->
              <!-- <td>{{ item.amount / 100 | number : "1.2-2" }}</td> -->
              <td>{{ item.object }}</td>
              <td>{{ item.id }}</td>
              <!-- <td>{{ item.created}}</td> -->
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
